<!-- 弹窗 -->
<template lang="html">
  <div class="alert" v-show="show">
    <div class="alertModel">
      <h5>提示 <span @click="close">×</span></h5>
      <div class="content">
        <p>{{msg}}</p>
      </div>
      <div class="bottom">
        <div class="btn btn-light" @click="close">
          关闭
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
    }
  },
  props:['show','msg'],
  methods:{
    close(){
      this.$emit('close',{show:false})
    }
  }
}
</script>

<style lang="css" scoped>
  .alert{
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.6);
    width: 100%;
    height: 100%;
    z-index: 99999;
  }
  .alertModel{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 300px;
    min-height: 100px;
    background: #fefefe;
    border-radius: 5px;
    border: 1px solid #ced4da;
  }
  .alertModel h5{
    text-align: center;
    font-size: 16px;
    padding: 10px 20px;
    border-bottom: 1px solid #e9ecef;
    color: #33434b;
    margin-bottom: 0;
  }
  .alertModel h5 span{
    float: right;
    font-size: 24px;
    margin-top: -10px;
  }
  .alertModel .content{
    text-align: center;
    font-size: 15px;
    padding: 10px 20px;
    line-height: 1.7;
    color: #666;
  }
  .alertModel .content p{margin-bottom: 0;}
  .alertModel .bottom{text-align: center;padding: 10px 0;}
  .alertModel .bottom span{

  }
</style>



// WEBPACK FOOTER //
// src/components/logout.vue